import { render, staticRenderFns } from "./KioskOrderTypeV2.vue?vue&type=template&id=652429e9&scoped=true"
import script from "./KioskOrderTypeV2.vue?vue&type=script&lang=js"
export * from "./KioskOrderTypeV2.vue?vue&type=script&lang=js"
import style0 from "./KioskOrderTypeV2.vue?vue&type=style&index=0&id=652429e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652429e9",
  null
  
)

export default component.exports